import { Component, ElementRef, EventEmitter, forwardRef, HostBinding, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { faSearch, faDollarSign, faTimes, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';

type InputState = "default" | "success" | "error" | ""

@Component({
  selector: 'mpro-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInputComponent),
      multi: true
    }
  ]
})
export class TextInputComponent implements ControlValueAccessor {

  faSearch = faSearch
  faDollarSign = faDollarSign
  faTimes = faTimes
  faSortDown = faSortDown
  faSortUp = faSortUp

  @Input() disabled: boolean;
  @Input() dark: boolean;

  @Input() title?: string
  @Input() subtitle?: string;
  @Input() readonly: boolean = false;
  @Input() info?: string
  @Input() placeholder?: string = '';
  @Input() successMsg?: string
  @Input() errorMsg?: string

  @Input() searchSign: boolean;
  @Input() dollarSign: boolean;
  @Input() dropdown: boolean;
  @Input() dropdownText: boolean = true

  @Input() inputValue: string = '';
  @Input() public isPassword: boolean = false;

  @HostBinding("class") @Input() inputState: InputState = "default"

  @ViewChild("input") input: ElementRef<HTMLInputElement>

  focused = false
  dropdownOpen = false

  @Output() search: EventEmitter<string> = new EventEmitter<string>()
  @Output() clear = new EventEmitter()
  @Output() focus: EventEmitter<void> = new EventEmitter()
  @Output() blur: EventEmitter<void> = new EventEmitter()

  onChange = (_: any) => { }; // No-op
  onTouched = (_: any) => { }; // No-op

  onFocus() {
    if (this.disabled) return
    this.focused = true
    this.focus.emit();
  }

  onFocusOut() {
    this.focused = false
    this.blur.emit();
  }

  focusInput() {
    if (this.disabled) return
    this.focused = true
    this.input.nativeElement.focus()
  }

  searchFunction() {
    if (this.disabled) return
    this.search.emit(this.inputValue)
    this.focusInput()
  }

  clearInput() {
    this.input.nativeElement.value = ""
    this.inputValue = ""
    this.clear.emit()
    this.focusInput()
    this.onChange(this.inputValue);
  }

  onType(event: any) {
    this.inputValue = event && event.target && event.target.value
    this.onChange(this.inputValue)
  }

  writeValue(val: any): void {
    this.inputValue = val
  }
  registerOnChange(fn: any): void {
    this.onChange = fn
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
